import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/WebAccount/" );
const basketInstance = new HttpService( "umbraco/api/Basket/" );

export const login = ( username, password ) => basketInstance.post( "Login", { username, password } );

export const logout = () => instance.post( "Logout" );

export const id = () => instance.get( "Id" );

export const isLoggedIn = () => instance.get( "IsLoggedIn" );
